(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product"]) return;
  try {
    
(() => {
  // ---- Gallery: slides, arrows, thumbs, lightbox --------------------------
  document.querySelectorAll('[data-gallery]').forEach((gallery) => {
    const slidesEl = gallery.querySelector('[data-gallery-slides]');
    const slides = Array.from(gallery.querySelectorAll('[data-gallery-slide]'));
    const thumbs = Array.from(gallery.querySelectorAll('[data-gallery-thumb]'));
    const counter = gallery.querySelector('[data-gallery-counter]');
    const lightbox = document.querySelector('[data-gallery-lightbox]');
    const count = slides.length;
    if (!slidesEl || !count) return;
    let index = 0;

    const paint = () => {
      thumbs.forEach((t, i) => { const on = i === index; t.classList.toggle('is-active', on); t.setAttribute('aria-selected', String(on)); });
      if (counter) counter.textContent = `${index + 1} / ${count}`;
    };
    const goTo = (i, smooth = true) => {
      index = (i + count) % count;
      slidesEl.scrollTo({ left: slides[index].offsetLeft - slidesEl.offsetLeft, behavior: smooth ? 'smooth' : 'auto' });
      paint();
    };
    gallery.querySelector('[data-gallery-prev]')?.addEventListener('click', () => goTo(index - 1));
    gallery.querySelector('[data-gallery-next]')?.addEventListener('click', () => goTo(index + 1));
    thumbs.forEach((t) => t.addEventListener('click', () => goTo(Number(t.dataset.galleryThumb))));

    // Swiping on touch: track which slide is centred.
    let scrollT;
    slidesEl.addEventListener('scroll', () => {
      clearTimeout(scrollT);
      scrollT = setTimeout(() => {
        const w = slidesEl.clientWidth || 1;
        const i = Math.round(slidesEl.scrollLeft / w);
        if (i !== index && i >= 0 && i < count) { index = i; paint(); }
      }, 80);
    }, { passive: true });

    // Keyboard on the stage
    gallery.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(index - 1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); goTo(index + 1); }
    });

    // ---- Lightbox (independent of the page gallery: paging here never moves
    // the gallery behind it) ----
    if (!lightbox || typeof lightbox.showModal !== 'function') return;
    const img = lightbox.querySelector('[data-lightbox-img]');
    const lbCounter = lightbox.querySelector('[data-lightbox-counter]');
    const zoomable = slides.map((s, i) => ({ i, src: s.dataset.zoomSrc, alt: s.dataset.zoomAlt })).filter((z) => z.src);
    if (!zoomable.length) return;
    let zi = 0;
    const showZoom = (k) => {
      zi = (k + zoomable.length) % zoomable.length;
      const z = zoomable[zi];
      img.src = z.src; img.alt = z.alt || '';
      if (lbCounter) lbCounter.textContent = zoomable.length > 1 ? `${zi + 1} / ${zoomable.length}` : '';
    };
    const openZoom = () => {
      const k = Math.max(0, zoomable.findIndex((z) => z.i === index));
      showZoom(k);
      lightbox.showModal();
    };
    gallery.querySelectorAll('[data-gallery-zoom]').forEach((b) => b.addEventListener('click', openZoom));
    lightbox.querySelector('[data-lightbox-close]')?.addEventListener('click', () => lightbox.close());
    lightbox.querySelector('[data-lightbox-prev]')?.addEventListener('click', (e) => { e.stopPropagation(); showZoom(zi - 1); });
    lightbox.querySelector('[data-lightbox-next]')?.addEventListener('click', (e) => { e.stopPropagation(); showZoom(zi + 1); });
    lightbox.addEventListener('click', (e) => { if (e.target === lightbox) lightbox.close(); });
    lightbox.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft') { e.preventDefault(); e.stopPropagation(); showZoom(zi - 1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); e.stopPropagation(); showZoom(zi + 1); }
    });
  });

  document.querySelectorAll('[data-variant-picker]').forEach((picker) => {
    const select = picker.querySelector('[data-variant-select]');
    const boxes = Array.from(picker.querySelectorAll('[data-variant-box]'));
    if (!select || !boxes.length) return;
    const paint = () => boxes.forEach((box) => {
      const on = box.dataset.variantBox === select.value;
      box.classList.toggle('is-selected', on);
      box.setAttribute('aria-checked', String(on));
    });
    boxes.forEach((box) => box.addEventListener('click', () => {
      if (select.value === box.dataset.variantBox) return;
      select.value = box.dataset.variantBox;
      select.dispatchEvent(new Event('change', { bubbles: true }));
      paint();
    }));
    select.addEventListener('change', paint);
    paint();
  });

  // Stock count + cart-aware quantity cap.
  // For variants whose inventory Shopify tracks (overselling off) the count
  // shows under the quantity field, and the field is capped at stock minus
  // whatever is already in the cart (cart-drawer.js publishes the cart on
  // window.NHC.cart and fires `nhc:cart` whenever it changes). When the whole
  // stock is in the cart the button reads "All in cart". Untracked /
  // continue-selling variants show no count and no cap.
  document.querySelectorAll('[data-product-root]').forEach((root) => {
    const qtyInput = root.querySelector('[data-quantity]');
    const level = root.querySelector('[data-stock-level]');
    const cap = root.querySelector('[data-quantity-cap]');
    const select = root.querySelector('[data-variant-select]');
    const button = root.querySelector('[data-add-to-cart]');
    if (!qtyInput) return;

    const state = () => {
      const src = select ? select.options[select.selectedIndex] : qtyInput;
      return {
        tracked: src.dataset.tracked === 'true',
        available: src.dataset.available === 'true',
        qty: parseInt(src.dataset.qty, 10) || 0,
        variantId: select ? src.value : qtyInput.dataset.variantId,
      };
    };

    const inCart = (variantId) => {
      const cart = window.NHC && window.NHC.cart;
      if (!cart || !cart.items) return 0;
      return cart.items.filter((i) => String(i.variant_id) === String(variantId)).reduce((s, i) => s + i.quantity, 0);
    };

    // The cap line replaces the stock line while it is showing.
    const setCap = (text) => {
      if (!cap) return;
      cap.textContent = text || '';
      cap.hidden = !text;
      if (level && !level.dataset.off) level.hidden = !!text;
    };

    const clamp = () => {
      const { tracked, qty, variantId } = state();
      let v = parseInt(qtyInput.value, 10);
      if (!v || v < 1) v = 1;
      if (tracked && qty > 0) {
        const held = inCart(variantId);
        const remaining = Math.max(0, qty - held);
        if (remaining > 0 && v > remaining) {
          v = remaining;
          setCap(held ? `Only ${remaining} more available · ${held} in your cart` : `Only ${remaining} available`);
        } else if (remaining > 0) {
          setCap('');
        }
      } else {
        setCap('');
      }
      qtyInput.value = v;
    };

    const render = () => {
      const { tracked, available, qty, variantId } = state();
      const show = tracked && qty > 0;
      if (level) {
        level.dataset.off = show ? '' : '1';
        if (show) {
          level.textContent = qty <= 5 ? `Only ${qty} left in stock` : `${qty} in stock`;
          level.classList.toggle('stock-level--low', qty <= 5);
        } else {
          level.textContent = '';
        }
        level.hidden = !show;
      }

      const held = show ? inCart(variantId) : 0;
      const remaining = show ? Math.max(0, qty - held) : Infinity;
      if (remaining === Infinity) qtyInput.removeAttribute('max'); else qtyInput.max = Math.max(1, remaining);

      if (button) {
        if (show && remaining === 0) {
          button.disabled = true;
          button.textContent = 'All in cart';
          button.dataset.capLocked = 'true';
          setCap(`${held} in your cart — that's all we have`);
          return;
        }
        if (button.dataset.capLocked === 'true') {
          button.dataset.capLocked = 'false';
          button.disabled = !available;
          button.textContent = available ? (button.dataset.addLabel || 'Add to cart') : (button.dataset.soldLabel || 'Sold out');
        }
      }
      setCap('');
      clamp();
    };

    qtyInput.addEventListener('change', clamp);
    qtyInput.addEventListener('blur', clamp);
    qtyInput.addEventListener('input', () => {
      const { tracked, qty, variantId } = state();
      const v = parseInt(qtyInput.value, 10);
      if (tracked && qty > 0 && v > qty - inCart(variantId)) clamp();
    });
    if (select) select.addEventListener('change', render);
    document.addEventListener('nhc:cart', render);
    document.addEventListener('nhc:cart-settled', render);
    render();
  });

  // Tidy the InventaCloud description markup (.prod_desc intro + facts list,
  // then an h3 + th/td spec table). Purely cosmetic; the HTML itself is untouched
  // in Shopify.
  document.querySelectorAll('[data-product-description] .prod_desc').forEach((desc) => {
    // The generator emits the product name again as a paragraph ending in a
    // comma right before the facts list — drop it.
    desc.querySelectorAll(':scope > p').forEach((p) => {
      const next = p.nextElementSibling;
      if (next && next.tagName === 'UL' && /,\s*$/.test(p.textContent)) p.remove();
    });
    // "Label:" → "Label" (the label is styled as its own line)
    desc.querySelectorAll('li > strong').forEach((s) => { s.textContent = s.textContent.replace(/:\s*$/, ''); });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nhc-brands"]) return;
  try {
    
(() => {
  // Brands filter: narrows the A–Z list as you type (case- and accent-
  // insensitive, matches anywhere in the name), hides empty letter groups,
  // greys out their jump-bar letters and keeps a live count.
  const input = document.querySelector('[data-brand-filter]');
  if (!input) return;
  const groups = Array.from(document.querySelectorAll('.brands-group'));
  const count = document.querySelector('[data-brand-count]');
  const none = document.querySelector('[data-brand-none]');
  const term = document.querySelector('[data-brand-term]');
  const norm = (s) => s.normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
  const items = groups.map((g) => ({ g, letter: g.id.replace('brands-', ''), lis: Array.from(g.querySelectorAll('li')).map((li) => ({ li, key: norm(li.textContent) })) }));
  const total = items.reduce((n, it) => n + it.lis.length, 0);
  const apply = () => {
    const q = norm(input.value);
    let shown = 0;
    items.forEach((it) => {
      let n = 0;
      it.lis.forEach((x) => { const on = !q || x.key.includes(q); x.li.hidden = !on; if (on) n++; });
      it.g.hidden = n === 0;
      shown += n;
      const j = document.querySelector('[data-jump="' + it.letter + '"]');
      if (j) j.classList.toggle('is-empty', n === 0);
    });
    count.textContent = q ? shown + ' of ' + total + ' brands' : total + ' brands';
    none.hidden = shown !== 0;
    term.textContent = input.value.trim();
  };
  input.addEventListener('input', apply);
  input.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') { input.value = ''; apply(); }
    if (e.key === 'Enter') { const first = document.querySelector('.brands-list li:not([hidden]) a'); if (first) first.click(); }
  });
  document.querySelector('[data-brand-clear]')?.addEventListener('click', () => { input.value = ''; apply(); input.focus(); });
  if (input.value) apply();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nhc-header"]) return;
  try {
    
(() => {
  // Mega menu: <details> gives click + keyboard for free; on a pointer device
  // we also open on hover with a short grace period so moving diagonally
  // into the panel does not close it. Only one panel is open at a time, and
  // Escape / outside click close it.

  // Off-canvas mobile drawer. theme.js already owns the hamburger (it flips
  // `drawer.open`, syncs aria-expanded and handles Escape), so instead of a
  // second toggle we expose `open` as a real property on the drawer element
  // that maps to the .is-open class, scroll lock and aria-hidden. The scrim and
  // close button route through the same property so every path stays in sync.
  const drawer = document.querySelector('[data-mobile-drawer]');
  if (drawer) {
    const panel = drawer.querySelector('.mobile-drawer__panel');
    const toggle = document.querySelector('[data-menu-toggle][aria-controls="' + drawer.id + '"]');
    const setOpen = (value) => {
      const open = Boolean(value);
      if (open === drawer.classList.contains('is-open')) return;
      drawer.classList.toggle('is-open', open);
      drawer.setAttribute('aria-hidden', String(!open));
      document.documentElement.classList.toggle('mobile-drawer-open', open);
      if (toggle) toggle.setAttribute('aria-expanded', String(open));
      if (open && panel) panel.focus({ preventScroll: true });
      drawer.dispatchEvent(new Event('toggle'));
    };
    Object.defineProperty(drawer, 'open', {
      get: () => drawer.classList.contains('is-open'),
      set: setOpen,
      configurable: true
    });
    drawer.querySelectorAll('[data-menu-close]').forEach((el) => el.addEventListener('click', () => { setOpen(false); if (toggle) toggle.focus(); }));
    // Leaving the mobile breakpoint (rotation, resize) must not strand a scroll lock.
    window.matchMedia('(min-width: 1101px)').addEventListener('change', (e) => { if (e.matches) setOpen(false); });
  }

  const nav = document.querySelector('[data-mega-nav]');
  if (!nav) return;
  const items = Array.from(nav.querySelectorAll('[data-mega]'));
  if (!items.length) return;
  const hover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  let closeT;

  const closeAll = (except) => items.forEach((d) => { if (d !== except && d.open) d.open = false; });

  items.forEach((d) => {
    d.addEventListener('toggle', () => { if (d.open) closeAll(d); });
    if (hover) {
      d.addEventListener('mouseenter', () => { clearTimeout(closeT); closeAll(d); d.open = true; });
      d.addEventListener('mouseleave', () => { closeT = setTimeout(() => { d.open = false; }, 160); });
      // A hover-opened panel should still navigate when the label is clicked.
      d.querySelector('summary')?.addEventListener('click', (e) => {
        if (d.open && e.detail > 0) {
          const href = d.querySelector('.mega__promo')?.getAttribute('href');
          if (href) { e.preventDefault(); window.location.href = href; }
        }
      });
    }
  });
  document.addEventListener('click', (e) => { if (!nav.contains(e.target)) closeAll(); });
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    const open = items.find((d) => d.open);
    if (open) { open.open = false; open.querySelector('summary')?.focus(); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nhc-slider"] && !Shopify.designMode) return;
  try {
    
(() => {
  document.querySelectorAll('[data-slider]').forEach((root) => {
    const slides = Array.from(root.querySelectorAll('[data-slide]'));
    const thumbs = Array.from(root.querySelectorAll('[data-slider-go]'));
    const status = root.querySelector('[data-slider-status]');
    const pauseBtn = root.querySelector('[data-slider-pause]');
    if (slides.length < 2) return;
    let index = 0, timer = null, userPaused = false, hovering = false;
    const interval = parseInt(root.dataset.interval, 10) || 6000;
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const show = (i, announce) => {
      index = (i + slides.length) % slides.length;
      slides.forEach((s, k) => {
        const on = k === index;
        s.classList.toggle('is-active', on);
        if (on) s.removeAttribute('aria-hidden'); else s.setAttribute('aria-hidden', 'true');
        s.querySelectorAll('a').forEach((a) => { a.tabIndex = on ? 0 : -1; });
        const img = s.querySelector('img[loading="lazy"]');
        if (on && img) img.loading = 'eager';
      });
      thumbs.forEach((t, k) => { const on = k === index; t.classList.toggle('is-active', on); t.setAttribute('aria-selected', String(on)); });
      if (announce && status) status.textContent = `Slide ${index + 1} of ${slides.length}`;
    };
    const stop = () => { clearInterval(timer); timer = null; };
    const start = () => {
      stop();
      if (root.dataset.autoplay !== 'true' || userPaused || hovering || reduce || document.hidden) return;
      timer = setInterval(() => show(index + 1, false), interval);
    };

    root.querySelector('[data-slider-prev]')?.addEventListener('click', () => { show(index - 1, true); start(); });
    root.querySelector('[data-slider-next]')?.addEventListener('click', () => { show(index + 1, true); start(); });
    thumbs.forEach((t) => t.addEventListener('click', () => { show(Number(t.dataset.sliderGo), true); start(); }));
    root.addEventListener('mouseenter', () => { hovering = true; stop(); });
    root.addEventListener('mouseleave', () => { hovering = false; start(); });
    root.addEventListener('focusin', () => { hovering = true; stop(); });
    root.addEventListener('focusout', (e) => { if (!root.contains(e.relatedTarget)) { hovering = false; start(); } });
    root.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft') { show(index - 1, true); }
      if (e.key === 'ArrowRight') { show(index + 1, true); }
    });
    document.addEventListener('visibilitychange', start);

    // Touch swipe
    let x0 = null;
    root.addEventListener('touchstart', (e) => { x0 = e.touches[0].clientX; }, { passive: true });
    root.addEventListener('touchend', (e) => {
      if (x0 === null) return;
      const dx = e.changedTouches[0].clientX - x0; x0 = null;
      if (Math.abs(dx) > 40) { show(index + (dx < 0 ? 1 : -1), true); start(); }
    }, { passive: true });

    if (pauseBtn) {
      if (root.dataset.autoplay !== 'true' || reduce) pauseBtn.hidden = true;
      pauseBtn.addEventListener('click', () => {
        userPaused = !userPaused;
        pauseBtn.setAttribute('aria-pressed', String(userPaused));
        pauseBtn.setAttribute('aria-label', userPaused ? 'Play slideshow' : 'Pause slideshow');
        root.classList.toggle('is-paused', userPaused);
        start();
      });
    }
    show(0, false);
    start();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recently-viewed"] && !Shopify.designMode) return;
  try {
    
(() => {
  const KEY = 'nhc:recent';
  const MAX = 12;
  const read = () => { try { const l = JSON.parse(localStorage.getItem(KEY) || '[]'); return Array.isArray(l) ? l : []; } catch (_) { return []; } };
  const write = (l) => { try { localStorage.setItem(KEY, JSON.stringify(l)); } catch (_) {} };

  document.querySelectorAll('[data-recently-viewed]').forEach(async (section) => {
    const current = section.dataset.current || '';
    const limit = parseInt(section.dataset.limit, 10) || 5;
    const grid = section.querySelector('[data-recently-viewed-grid]');
    const previous = read().filter((h) => h && h !== current);
    if (current) write([current, ...previous].slice(0, MAX));

    const handles = previous.slice(0, limit);
    if (!handles.length || !grid) return;
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    // No Accept: application/json header here — on a product URL Shopify
    // treats that as a request for the product JSON and ignores ?sections=.
    const fragments = await Promise.all(handles.map(async (handle) => {
      try {
        const r = await fetch(`${root}products/${encodeURIComponent(handle)}?sections=recently-viewed-card`);
        if (r.status === 404) return null; // product gone — prune it
        if (!r.ok) return '';
        const json = await r.json();
        return json['recently-viewed-card'] || '';
      } catch (_) { return ''; }
    }));

    const dead = [];
    fragments.forEach((html, i) => {
      if (html === null) { dead.push(handles[i]); return; }
      const card = html ? new DOMParser().parseFromString(html, 'text/html').querySelector('.product-card') : null;
      if (!card) return;
      card.classList.add('is-visible');
      grid.appendChild(document.adoptNode(card));
    });
    if (dead.length) write(read().filter((h) => !dead.includes(h)));
    if (grid.children.length) section.hidden = false;
  });
})();

  } catch(e) { console.error(e); }
})();
})();
